<div class="d-flex justify-content-center align-items-center" style="min-height: 60vh;">
  <div class="text-center">
    <div class="text-muted mb-3" style="font-size: 5rem; line-height: 1;">
      <fa-icon [icon]="faMapSigns"></fa-icon>
    </div>
    <h1 class="display-4 fw-bold mb-2">404</h1>
    <h5 class="fw-semibold mb-2">Page Not Found</h5>
    <p class="text-muted mb-4">The page you're looking for doesn't exist or has been moved.</p>
    <a routerLink="/dashboard" class="btn btn-primary">
      <fa-icon [icon]="faArrowLeft" class="me-2"></fa-icon>Back to Dashboard
    </a>
  </div>
</div>
